<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Print - Change Control Note</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>

<div mat-dialog-content class="">
  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
  </div>
</div>